import { Injectable, EventEmitter } from '@angular/core';
import {
    WizzyFilterItem,
    WizzyFilters,
    WizzyPayload,
    WizzyProduct,
} from './search-page.data';
import { MarcheAPIService } from '../@core/api/marche-api.service';
import { stringify } from 'querystring';
import { Observable, of } from 'rxjs';
import {
    ErrorWrapper,
    ResponseWrapper,
    WizResponseWrapper,
} from '../@shared/models/response-wrapper.model';
import { tap } from 'rxjs/operators';
import { ApplicationRouterService } from '../@core/application-router/application-router.service';
import { LFPDATA } from '../@shared-except-main/collection-listing-filter-page/collection-listing-filter-page.data';

@Injectable({
    providedIn: 'root',
})
export class SearchPageService {
    static SP_DATA_PAGINATION_API = 'https://api.wizzy.ai/v1/products/filter';
    currentPage = -1;
    wizData: WizzyPayload | undefined;
    wizProducts: WizzyProduct[] = [];
    errors: ErrorWrapper[] | undefined = [];
    filters: { [p: string]: string | string[] } = {};
    scrollPos = -1;
    filterSelectionEvent: EventEmitter<FIlterSelection> =
        new EventEmitter<FIlterSelection>();
    private pageScrollPositions: { [page: number]: number } = {};
    wizFacets: Array<WizzyFilterItem> = [];
    wizFilters: LFPDATA = new LFPDATA();
    newPage = -1;
    isDestroyed = false;
    filterTab = false;

    constructor(
        private marcheAPIService: MarcheAPIService,
        private applicationRouterService: ApplicationRouterService
    ) {}

    getSearchData(
        wizFilter: WizzyFilters | undefined | null,
        filters: { [p: string]: string | string[] },
        page: number,
        sort: any,
        changeListingUrl?: boolean
    ): Observable<any> {
        return this.marcheAPIService
            .postRequest<WizResponseWrapper<WizzyPayload> | null>(
                SearchPageService.SP_DATA_PAGINATION_API,
                this.filters,
                {
                    filters: JSON.stringify({
                        ...wizFilter,
                        inStock: [true, false],
                    }),
                },
                true
            )
            .pipe(
                tap(res => {
                    if (res?.payload) {
                        if (page === 0) {
                            this.wizProducts = [];
                            this.applicationRouterService.differNavApiCall.emit(
                                { navCall: true, pageId: 'sp' }
                            );
                        }
                        this.currentPage = page;
                        this.filters = filters;
                        this.errors = [];
                    } else {
                        this.wizProducts = [];
                    }
                })
            );
    }

    getCurrentPage(): number {
        return this.currentPage;
    }

    getPageDestroy(): boolean {
        return this.isDestroyed;
    }

    setPageDestroy(value: boolean) {
        this.isDestroyed = value;
    }

    getFilterTabState(): boolean {
        return this.filterTab;
    }

    setFilterTabState(value: boolean) {
        this.filterTab = value;
    }

    getNewPage(): number {
        return this.newPage;
    }

    setNewPage(page: number) {
        this.newPage = page;
    }

    setScrollPosRestore(scroll: number) {
        this.scrollPos = scroll;
    }

    getScrollPos(filters: { [p: string]: string | string[] }): number {
        if (stringify(filters) === stringify(this.filters)) {
            return this.scrollPos;
        } else {
            return -1;
        }
    }

    getFilters(): { [p: string]: string | string[] } {
        return this.filters;
    }

    setFilters(filters: { [p: string]: string | string[] }) {
        this.filters = filters;
    }

    setScrollPosition(page: number, scrollPos: number) {
        this.pageScrollPositions[page] = scrollPos;
    }

    getScrollPosition(page: number): number {
        return this.pageScrollPositions[page++];
    }

    setWizProductsData(products: WizzyProduct[]) {
        this.wizProducts.push(...products);
    }

    getWizProductsData(): WizzyProduct[] {
        return this.wizProducts;
    }

    clearWizProductsData() {
        this.wizProducts = [];
    }

    setWizData(wizData: WizzyPayload | undefined) {
        this.wizData = wizData;
    }

    getWizData(): WizzyPayload | undefined {
        return this.wizData;
    }

    clearWizData() {
        this.wizData = undefined;
    }

    setWizFacets(facets: Array<WizzyFilterItem>) {
        this.wizFacets = facets;
    }

    getWizFacets(): Array<WizzyFilterItem> {
        return this.wizFacets;
    }

    clearWizFacets() {
        this.wizFacets = [];
    }

    setWizFilters(filters: LFPDATA) {
        this.wizFilters = filters;
    }

    getWizFilters(): LFPDATA {
        return this.wizFilters;
    }

    clearWizFilters() {
        this.wizFilters = new LFPDATA();
    }
}
export class FIlterSelection {
    action: string | string[];
    collectionName: string | string[];
    key: string | string[];
    lable: string | string[];
    constructor(
        action: string | string[],
        collectionName: string | string[],
        key: string | string[],
        lable: string | string[]
    ) {
        this.collectionName = collectionName;
        this.key = key;
        this.lable = lable;
        this.action = action;
    }
}
